import React, { createContext, useState } from "react";

const AppContext = createContext();

const AppProvider = ({ children }) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [confirmationResult, setConfirmationResult] = useState(null); // { success: boolean, message?: string, pdfUrl?: string }

    const handlePageChange = (index) => {
        setCurrentPage(index);
    };

    return (
        <AppContext.Provider value={{ currentPage, handlePageChange, confirmationResult, setConfirmationResult }}>
            {children}
        </AppContext.Provider>
    );
};

export { AppContext, AppProvider };
